import { faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Divider, Menu, MenuItem, styled } from "@mui/material";
import { FC, MouseEvent, useContext, useMemo, useState } from "react";
import { Link as RouteLink, useParams } from 'react-router-dom';
import ProjectContext from "../../../contexts/data/ProjectContext";
import ProjectsContext from "../../../contexts/data/ProjectsContext";
import { LinkContext } from "../../../contexts/layouts/LinkContext";

const StyledDivider = styled(Divider)(() => ({
    margin: `0 !important`
}));

const NavigationProjectSelector: FC = () => {
    const { createProjectLink, projectLinkEnabled } = useContext(LinkContext);
    
    const { data: project} = useContext(ProjectContext);
    const { data: projects} = useContext(ProjectsContext);

    const params = useParams();

    const projectId = Number(params.projectId);
    
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

    const handleMenu = (event: MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const list = useMemo(() => {
        return projects?.map((x, i, a) => {
            return (
                [
                    <MenuItem 
                        key={x.id} 
                        component={RouteLink} 
                        to={createProjectLink(x)} 
                        onClick={handleClose}
                    >
                        {x.name}
                    </MenuItem>,
                    i < (a.length - 1) ? <StyledDivider key={`${x.id}-divider`} /> : null
                ]
            );
        })
    }, [projects, createProjectLink, handleClose])

    if (!projectLinkEnabled) {
        return null;
    }
    
    return (
        <>
            <Button
                id="btn-projects"
                color="primary"
                aria-label="project selection"
                aria-controls="menu-projects"
                aria-haspopup="true"
                sx={{mr: 2}}
                onClick={handleMenu}
                endIcon={<FontAwesomeIcon icon={faChevronDown} fixedWidth style={{fontSize: '1rem'}} />}
            >
                {
                    projectId && project ?
                        project.name :
                        'No Project Selected'
                }
            </Button>
            <Menu
                id="menu-projects"
                anchorEl={anchorEl}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                open={anchorEl?.id === 'btn-projects'}
                onClose={handleClose}
                slotProps={{
                    list: {
                        disablePadding: true
                    }
                }}
            >
                <MenuItem component={RouteLink} to={createProjectLink(undefined)} onClick={handleClose}>All Projects</MenuItem>
                <StyledDivider />
                {list}
            </Menu>
        </>
    )
}

export default NavigationProjectSelector;